export default __webpack_public_path__ + "static/media/kontakt.4b9611e5.jpg";